module.exports = __webpack_public_path__ + "img/expired.7bc89470.svg";